import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BadgeComponent, Size } from '@interacta-shared/ui';
import { CreationDateComponent } from '@interacta-shared/ui-common';
import { AttachmentPreviewComponent } from '@interacta/feature-attachment';
import { AttachmentIconComponent } from '@interacta/ui-attachment';
import {
    getAttachmentPreviewImageLink,
    IAttachment,
} from '@interacta/util-post';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-ai-shared-attachment-chip',
    templateUrl: './ai-shared-attachment-chip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AttachmentIconComponent,
        AttachmentPreviewComponent,
        BadgeComponent,
        CreationDateComponent,
        MatTooltipModule,
        NgClass,
        TranslatePipe,
    ],
})
export class AISharedAttachmentChipComponent {
    readonly attachment = input.required<IAttachment>();
    /** i18n key of the badge that replaces the metadata when the source is no longer viewable. */
    readonly unavailableLabel = input<string | null>(null);
    /** `regular` is the card above a message, `small` the one inside the question input. */
    readonly size = input<Extract<Size, 'regular' | 'small'>>('regular');

    readonly attachmentClick = output();

    readonly hasVisualPreview = computed(
        () =>
            !this.unavailableLabel() &&
            !!getAttachmentPreviewImageLink(this.attachment()),
    );
}
